<template>
<div class="prizes_carousel">
  <div class="swiper swiper_prizes_carousel">
    <div class="swiper-wrapper owl-carousel">
      <div class="swiper-slide" v-for="prize in newArray" :key="prize.type">
        <div class="carousel_prize_container" >
          <img :src="prize.imgUrl" alt="" class="">
          <p> {{ prize.headline }} </p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import 'owl.carousel';

export default {
  name: 'prize-carousel',
  data() {
    return {
      newArray: [],
    };
  },
  props: ['type'],
  methods: {
    ...mapActions('profile', [
      'storeAvailablePrizeTypes',
    ]),
  },
  mounted() {
    let length = 0;
    let choose = '';
    if (this.type === 1) {
      choose = 'MONTHLY';
    } else if (this.type === 2) {
      choose = 'WEEKLY';
    }
    // eslint-disable-next-line
    for (const property in this.getCarouselPrizes) {
      if (this.getCarouselPrizes[property].type === choose) {
        length = +1;
        this.newArray.push(this.getCarouselPrizes[property]);
      }
    }
    this.storeAvailablePrizeTypes(this.getLocale).then(() => {
      this.$nextTick(() => {
        /*eslint-disable */
        // default home page carousel
        $('.swiper-wrapper').owlCarousel({
          loop: length > 1 ? true : false,
          responsiveClass: true,
          dots: length > 1 ? true : false,
          autoplay: length > 1 ? true : false,
          autoplayTimeout: 5000,
          autoplayHoverPause: length > 1 ? true : false,
          navContainer: '.carousel__nav',
          dotsContainer: '.carousel__dots',
          navText: length >= 1 ? ['<i class=\'icon-arrow-left\'></i>', '<i class=\'icon-arrow-right\'></i>'] : '',
          responsive: {
            0: {
              items: length >= 3 ? 3 : length,
              nav: true,
            },
          },
        });
      });
    });
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
    ...mapGetters('profile', [
      'getDailyPrize',
      'getWeeklyPrize',
      'getMonthlyPrize',
      'getCarouselPrizes',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/visitor/PrizeCarousel.vue